import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';

import { DefaultSeoService } from '@rpgc-ai/services/seo/default-seo.service';
import { SeoService } from '@rpgc-ai/services/seo/seo.service';
import { SeoDataService } from '@rpgc-ai/services/seo/seo-data.service';
import { LanguageService } from '@rpgc-ai/services/translate/language.service';

import { catchError, forkJoin, map, tap } from 'rxjs';

export const publicProfileSeoResolver: ResolveFn<void> = (route) => {
  const seoDataService = inject(SeoDataService);
  const seoService = inject(SeoService);
  const defaultSeoService = inject(DefaultSeoService);
  const languageService = inject(LanguageService);

  const profileId = route.params['id'];
  if (!profileId) {
    return;
  }

  const routeLanguage = languageService.getLanguageForRoute(route);

  return forkJoin([seoDataService.getPublicProfile(profileId), defaultSeoService.selectTexts(routeLanguage)]).pipe(
    tap(([profile, defaultSeo]) => {
      const title = `${profile.slug ?? 'Profile'} | CAICHAT`;
      const description = profile.highlights || defaultSeo.description;

      seoService.setTitle(title);
      seoService.setTag('description', description, 'name');
      seoService.setTag('og:title', title, 'property');
      seoService.setTag('og:description', description, 'property');
    }),
    map(() => void 0),
    catchError((error: unknown) => {
      // eslint-disable-next-line no-console
      console.error('publicProfileSeoResolver: failed to load public profile SEO data', error);
      return defaultSeoService.apply(routeLanguage);
    }),
  );
};
